import APIService from "./APIService";
import { useState, useRef } from "react";
import { useForm } from "react-hook-form";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import { useTranslation } from "react-i18next";
import i18n from "i18next";

import ServiceClassPicker from "./ServiceClassPicker";
import TimberMaterialPicker from "./TimberMaterialPicker";
import ListelTimberMaterialPicker from "./ListelTimberMaterialPicker";
import ScrewPicker from "./ScrewPicker";
import CodePicker from "./CodePicker";
import ColoredLine from "./ColoredLine";

export default function FissaggioCoibente(props) {
  const ServiceClassRef = useRef(null);
  const CodeRef = useRef(null);
  const TimberMaterialRef = useRef(null);
  const TimberBattelsMaterialRef = useRef(null);
  const ScrewPickerRef = useRef(null);
  const [LoadDuration, SetLoadDuration] = useState("1");
  const [isKmodDisabled, setKmodDisabled] = useState(true);
  const [CreateReport, SetCreateReport] = useState("");
  const [Image, setImage] = useState("coibente/Coibente_2.png");
  const [Ratio, setRatio] = useState("");
  const [validData, setValidData] = useState(true);
  const [resultMessages, setResultMessages] = useState("");
  const [resistant, setResistant] = useState(1);
  const [facade, setFacade] = useState(0);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues: { HookUseEta: false } });

  const getRatio = () => {
    const BeamB = parseFloat(getValues("HookB"));
    const BeamH = parseFloat(getValues("HookH"));
    var BeamMaterial = parseInt(TimberMaterialRef.current.getData());
    const BeamDistance = parseFloat(getValues("HookI"));
    const BeamAngle = parseFloat(getValues("HookBeamAngle"));

    const ListelB = parseFloat(getValues("HookLb"));
    const ListelH = parseFloat(getValues("HookLp"));
    const ListelMaterial = parseInt(TimberBattelsMaterialRef.current.getData());
    const Eb = parseFloat(getValues("HookLeb"));

    const InsulationCompressionResistance = parseFloat(getValues("HooksIsoSigma"));
    const InsulationE = parseFloat(getValues("HooksIsoE"));
    const InsulationThickness = parseFloat(getValues("HooksIsoSp"));

    var ScrewType = parseInt(ScrewPickerRef.current.getData());
    const Steps1 = resistant > 0 ? parseInt(getValues("HookIc1")) : parseInt(getValues("HookIc"));
    const CoupleStep = parseInt(getValues("HookStepX"));
    const ScrewAngle1 = parseInt(getValues("HookAlfa"));

    var ServiceClass = parseInt(ServiceClassRef.current.getData());
    const language = i18n.language;
    var kmod = parseFloat(getValues("HookKmod"));
    if (isNaN(kmod)) {
      kmod = 0.0;
    }
    const PermamentStructural = parseFloat(getValues("HookG1k"));
    const PermamentNotStructural = parseFloat(getValues("HookG2k"));
    const LiveLoad = parseFloat(getValues("HookQ1k"));
    const SnowLoad = parseFloat(getValues("HookSnow"));
    const WindPressureLoad = parseFloat(getValues("HookWindp"));
    const WindDepressureLoad = parseFloat(getValues("HookWindd"));
    const SpessoreTavolato = parseFloat(getValues("HookSpt"));

    var Facade = getValues("HookFacade") ? 1 : 0;
    var CompressionResistance = getValues("HookResistant") ? 1 : 0;

    const email = JSON.parse(sessionStorage.getItem("email"));
    const address = process.env.REACT_APP_SERVER_URL_INSULATION_RATIO;
    var code = parseInt(CodeRef.current.getData());

    var loadDuration = parseInt(LoadDuration);

    const promiseResult = APIService.GetRatio(
      {
        BeamB,
        BeamH,
        BeamMaterial,
        BeamDistance,
        BeamAngle,
        ListelB,
        ListelH,
        ListelMaterial,
        Eb,
        InsulationCompressionResistance,
        InsulationE,
        InsulationThickness,
        ScrewType,
        Steps1,
        ScrewAngle1,
        ServiceClass,
        language,
        kmod,
        PermamentStructural,
        PermamentNotStructural,
        LiveLoad,
        SnowLoad,
        WindPressureLoad,
        WindDepressureLoad,
        CreateReport,
        loadDuration,
        email,
        code,
        SpessoreTavolato,
        CoupleStep,
        Facade,
        CompressionResistance
      },
      address
    );
    promiseResult.then((value) => {
      console.log(value);
      setRatio(value["ratio"]);
      setResultMessages(value["result"]);
      setValidData(value["valid"]);
    });
  };

  const getReport = () => {
    const BeamB = parseFloat(getValues("HookB"));
    const BeamH = parseFloat(getValues("HookH"));
    var BeamMaterial = parseInt(TimberMaterialRef.current.getData());
    const BeamDistance = parseFloat(getValues("HookI"));
    const BeamAngle = parseFloat(getValues("HookBeamAngle"));

    const ListelB = parseFloat(getValues("HookLb"));
    const ListelH = parseFloat(getValues("HookLp"));
    const ListelMaterial = parseInt(TimberBattelsMaterialRef.current.getData());
    const Eb = parseFloat(getValues("HookLeb"));

    const InsulationCompressionResistance = parseFloat(getValues("HooksIsoSigma"));
    const InsulationE = parseFloat(getValues("HooksIsoE"));
    const InsulationThickness = parseFloat(getValues("HooksIsoSp"));

    var ScrewType = parseInt(ScrewPickerRef.current.getData());
    const Steps1 = resistant > 0 ? parseInt(getValues("HookIc1")) : parseInt(getValues("HookIc"));
    const CoupleStep = parseInt(getValues("HookStepX"));
    const ScrewAngle1 = parseInt(getValues("HookAlfa"));

    var ServiceClass = parseInt(ServiceClassRef.current.getData());
    const language = i18n.language;
    var kmod = parseFloat(getValues("HookKmod"));
    if (isNaN(kmod)) {
      kmod = 0.0;
    }
    const PermamentStructural = parseFloat(getValues("HookG1k"));
    const PermamentNotStructural = parseFloat(getValues("HookG2k"));
    const LiveLoad = parseFloat(getValues("HookQ1k"));
    const SnowLoad = parseFloat(getValues("HookSnow"));
    const WindPressureLoad = parseFloat(getValues("HookWindp"));
    const WindDepressureLoad = parseFloat(getValues("HookWindd"));
    const SpessoreTavolato = parseFloat(getValues("HookSpt"));

    var Facade = getValues("HookFacade") ? 1 : 0;
    var CompressionResistance = getValues("HookResistant") ? 1 : 0;

    const email = JSON.parse(sessionStorage.getItem("email"));
    const address = process.env.REACT_APP_SERVER_URL_INSULATION_REPORT;
    var code = parseInt(CodeRef.current.getData());

    var loadDuration = parseInt(LoadDuration);
    
    const promiseResult = APIService.GetReportComplete(
      {
        BeamB,
        BeamH,
        BeamMaterial,
        BeamDistance,
        BeamAngle,
        ListelB,
        ListelH,
        ListelMaterial,
        Eb,
        InsulationCompressionResistance,
        InsulationE,
        InsulationThickness,
        ScrewType,
        Steps1,
        ScrewAngle1,
        ServiceClass,
        language,
        kmod,
        PermamentStructural,
        PermamentNotStructural,
        LiveLoad,
        SnowLoad,
        WindPressureLoad,
        WindDepressureLoad,
        CreateReport,
        loadDuration,
        email,
        code,
        SpessoreTavolato,
        CoupleStep,
        Facade,
        CompressionResistance
      },
      address
    );
    promiseResult.then((response) => console.log("downloaded")).catch((error) => console.log("error", error));
    setRatio("");
    setResultMessages("");
    setValidData("");
  };

  const onErrors = (errors) => console.error(errors);

  const onSubmit = (event) => {
    if (CreateReport === 0) {
      getRatio();
    } else if (CreateReport === 1) {
      getReport();
    }
  };

  const onChangeLoadDuration = (event) => {
    const value = event.target.value;
    SetLoadDuration(value);
    if (value === "0") {
      setKmodDisabled(false);
    } else {
      setKmodDisabled(true);
    }
  };

  function handleChangeTotalH(e) {
    var maxH = 0.0;
    var minH = 0.0;
    const currentH = parseFloat(getValues("HookH"));
    maxH += currentH;
    const currentSpt = parseFloat(getValues("HookSpt"));
    maxH += currentSpt;
    minH += currentSpt;
    const currentLp = parseFloat(getValues("HookLp"));
    maxH += currentLp;
    minH += currentLp;
    const currentIsoSp = parseFloat(getValues("HooksIsoSp"));
    maxH += currentIsoSp;
    minH += currentIsoSp;
    var screwAngle = parseInt(getValues("HookAlfa"));
    maxH = maxH / Math.sin(screwAngle * 3.14 / 180);
    minH = minH / Math.sin(screwAngle * 3.14 / 180);
    ScrewPickerRef.current.setMaxL(maxH - 30.0);
    ScrewPickerRef.current.setMinL(minH + 48.0);
  }

  function updateImage() {
    var isFacade = getValues("HookFacade");
    var isResistant = getValues("HookResistant");
    if (isFacade){
      setImage("coibente/Coibente_1.png");
    }
    else{
      if (isResistant){
        setImage("coibente/Coibente_2.png");
      }
      else{
        setImage("coibente/Coibente_3.png");
      }
    }
  }

  function updateIsolant(e) {
    var isResistant = getValues("HookResistant");
    setResistant(isResistant ? 1 : 0);
    updateImage();
  }

  function updateFacade(e) {
    var isFacade = getValues("HookFacade");
    setFacade(isFacade ? 1 : 0);
    updateImage();
  }

  const { t } = useTranslation();

  return (
    <form class="max-w-fit" onSubmit={handleSubmit(onSubmit, onErrors)}>
      <div class="flex flex-wrap -mx-2 mb-5">
        <div class="form-col1_3">
          <TransformWrapper>
            <TransformComponent>
              <img src={Image} alt="" />
            </TransformComponent>
          </TransformWrapper>
        </div>
        <div class="form-col1_3"></div>
        <div class="form-col1_3"></div>

        <div class="form-col1_6">
          <CodePicker ref={CodeRef}></CodePicker>
        </div>
        <ServiceClassPicker ref={ServiceClassRef} />
        <div class="form-col1_6">
          <label class="form-label" for="grid-LoadDuration">
            {t("LoadDuration")}
          </label>
          <select class="form-select" id="grid-LoadDuration" name="grid-LoadDuration" onChange={onChangeLoadDuration} defaultValue={LoadDuration}>
            <option value="1">{t("Permanente")}</option>
            <option value="2">{t("Lunga")}</option>
            <option value="3">{t("Media")}</option>
            <option value="4">{t("Breve")}</option>
            <option value="5">{t("Istantanea")}</option>
            <option value="0">{t("Manual")}</option>
          </select>
        </div>
        {isKmodDisabled ? (
          <div class="form-col1_6" />
        ) : (
          <div class="form-col1_6">
            <label class="form-label" for="grid-kmod">
              {t("Kmod")}
            </label>
            <input
              class="form-input"
              id="grid-kmod"
              type="number"
              step={0.01}
              placeholder={t("Kmod")}
              defaultValue={1}
              readOnly={isKmodDisabled}
              {...register("HookKmod", {
                required: t("Required"),
                min: {
                  value: 0.01,
                  message: t("Minimo") + " 0.01",
                },
                max: {
                  value: 10,
                  message: t("Massimo") + " 10",
                },
              })}
            ></input>
            <p class="form-error">{errors.HookKmod?.message}</p>
          </div>
        )}
        <div class="form-col1_6" />
        <div class="form-col1_6" />

        <ColoredLine text={t("Carichi")} />
        <div class="form-col1_6">
          <label class="form-label" for="grid-g2k">
            G<sub>1k</sub> [kN/m<sup>2</sup>]
          </label>
          <input
            class="form-input"
            id="grid-g2k"
            type="number"
            step={0.01}
            defaultValue={2}
            placeholder="G1k"
            {...register("HookG1k", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p class="form-error">{errors.HookG1k?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-g2k">
            G<sub>2k</sub> [kN/m<sup>2</sup>]
          </label>
          <input
            class="form-input"
            id="grid-g2k"
            type="number"
            step={0.01}
            defaultValue={1}
            placeholder="G2k"
            {...register("HookG2k", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p class="form-error">{errors.HookG2k?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-q1k">
            Q<sub>1k</sub> [kN/m<sup>2</sup>]
          </label>
          <input
            class="form-input"
            id="grid-q1k"
            type="number"
            step={0.01}
            defaultValue={2}
            placeholder="Q1k"
            {...register("HookQ1k", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p class="form-error">{errors.HookQ1k?.message}</p>
        </div>
        <div class="form-col1_6" hidden={facade === 1}>
          <label class="form-label" for="grid-snow">
            {t("Neve")} [kN/m<sup>2</sup>]
          </label>
          <input
            class="form-input"
            id="grid-snow"
            type="number"
            step={0.01}
            defaultValue={1}
            placeholder={t("Neve")}
            {...register("HookSnow", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p class="form-error">{errors.HookSnow?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-windp">
            {t("PressioneVento")} [kN/m<sup>2</sup>]
          </label>
          <input
            class="form-input"
            id="grid-windp"
            type="number"
            step={0.01}
            defaultValue={0.6}
            placeholder={t("PressioneVento")}
            {...register("HookWindp", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p class="form-error">{errors.HookWindp?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-windd">
            {t("DepressioneVento")} [kN/m<sup>2</sup>]
          </label>
          <input
            class="form-input"
            id="grid-windd"
            type="number"
            step={0.01}
            defaultValue={-0.6}
            placeholder={t("DepressioneVento")}
            {...register("HookWindd", {
              required: t("Required"),
              min: {
                value: -10000,
                message: t("Minimo") + " -10000",
              },
              max: {
                value: 0,
                message: t("Massimo") + " 0",
              },
            })}
          />
          <p class="form-error">{errors.HookWindd?.message}</p>
        </div>
        <div class="form-col1_6" hidden={facade !== 1}></div>

        <ColoredLine text={t("Trave")} />
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-B">
            {t("BeamBase")}
          </label>
          <input
            class="form-input"
            id="grid-beam-B"
            type="number"
            step={1}
            placeholder="B [mm]"
            defaultValue={200}
            {...register("HookB", {
              required: t("Required"),
              min: {
                value: 100,
                message: t("Minimo") + " 100mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p class="form-error">{errors.HookB?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-H">
            {t("BeamHeight")}
          </label>
          <input
            class="form-input"
            id="grid-beam-H"
            type="number"
            step={1}
            placeholder="H [mm]"
            defaultValue={400}
            {...register("HookH", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeTotalH(e);
              },
              min: {
                value: 100,
                message: t("Minimo") + " 100mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p class="form-error">{errors.HookH?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-I">
            {t("InterasseTravi")}
          </label>
          <input
            class="form-input"
            id="grid-beam-"
            type="number"
            step={1}
            placeholder="i [mm]"
            defaultValue={700}
            {...register("HookI", {
              required: t("Required"),
              min: {
                value: 200,
                message: t("Minimo") + " 200mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p class="form-error">{errors.HookI?.message}</p>
        </div>
        <div class="form-col1_6" hidden={facade > 0}>
          <label class="form-label" for="grid-beam-beta">
            {t("AngoloTrave")}
          </label>
          <input
            class="form-input"
            id="grid-beam-beta"
            type="number"
            step={0.1}
            placeholder={t("AngoloTrave")}
            defaultValue={10}
            {...register("HookBeamAngle", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0°",
              },
              max: {
                value: 90,
                message: t("Massimo") + " 90°",
              },
            })}
          />
          <p class="form-error">{errors.HookBeamAngle?.message}</p>
        </div>
        <TimberMaterialPicker ref={TimberMaterialRef} />
        <div class="form-col1_6"></div>

        <ColoredLine text={t("Tavolato")} />
        <div class="form-col1_6">
          <label class="form-label" for="grid-tav">
            {t("SpessoreTavolato")}
          </label>
          <input
            class="form-input"
            id="grid-tav"
            type="number"
            step={1}
            defaultValue={50}
            placeholder={"St [mm]"}
            {...register("HookSpt", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeTotalH(e);
              },
              min: {
                value: 0,
                message: t("Minimo") + " 0mm",
              },
              max: {
                value: 100,
                message: t("Massimo") + " 100mm",
              },
            })}
          />
          <p class="form-error">{errors.HookSpt?.message}</p>
        </div>

        <ColoredLine text={t("ListelloVentilazione")} />
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-lb">
            {t("ListelloB")}
          </label>
          <input
            class="form-input"
            id="grid-beam-lb"
            type="number"
            step={1}
            defaultValue={100}
            placeholder={t("ListelloB")}
            {...register("HookLb", {
              required: t("Required"),
              min: {
                value: 60,
                message: t("Minimo") + " 60mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10000",
              },
            })}
          />
          <p class="form-error">{errors.HookLb?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-lh">
            {t("ListelloH")}
          </label>
          <input
            class="form-input"
            id="grid-lh"
            type="number"
            step={1}
            defaultValue={100}
            placeholder={t("ListelloH")}
            {...register("HookLp", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeTotalH(e);
              },
              min: {
                value: 40,
                message: t("Minimo") + " 40mm",
              },
              max: {
                value: 200,
                message: t("Massimo") + " 200mm",
              },
            })}
          />
          <p class="form-error">{errors.HookLp?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-leb">
            {t("ListelloI")}
          </label>
          <input
            class="form-input"
            id="grid-leb"
            type="number"
            step={1}
            defaultValue={500}
            placeholder={t("ListelloI")}
            {...register("HookLeb", {
              required: t("Required"),
              min: {
                value: 1,
                message: t("Minimo") + " 1mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p class="form-error">{errors.HookLeb?.message}</p>
        </div>
        <ListelTimberMaterialPicker ref={TimberBattelsMaterialRef} />
        <div class="form-col1_6"></div>
        <div class="form-col1_6"></div>

        <ColoredLine text={t("MaterialeIsolante")} />
        <div class="form-col1_6" hidden={facade > 0}>
          <label class="form-label" for="grid-resistente">
            {t("ResistenteCompressione")}
          </label>
          <input
            type="checkbox"
            id="grid-resistente"
            name="grid-resistente"
            class="greencheck"
            defaultChecked={true}
            {...register("HookResistant", {
              onChange: (e) => {
                updateIsolant(e);
              },
            })}
          />
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-facade">
            {t("IsolanteFacciata")}
          </label>
          <input
            type="checkbox"
            id="grid-facade"
            name="grid-facade"
            class="greencheck"
            defaultChecked={false}
            {...register("HookFacade", {
              onChange: (e) => {
                updateFacade(e);
              },
            })}
          />
        </div>
        <div class="form-col1_6" hidden={resistant === 0}>
          <label class="form-label" for="grid-iso-sigma">
            {t("IsolamentoResComp")} [kPa]
          </label>
          <input
            class="form-input"
            id="grid-iso-sigma"
            type="number"
            step={0.01}
            defaultValue={500.0}
            placeholder={t("IsolamentoResComp")}
            {...register("HooksIsoSigma", {
              required: t("Required"),
              min: {
                value: 0.01,
                message: t("Minimo") + " 0.01",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10000",
              },
            })}
          />
          <p class="form-error">{errors.HooksIsoSigma?.message}</p>
        </div>
        <div class="form-col1_6" hidden={resistant === 0}>
          <label class="form-label" for="grid-iso-e">
            {t("IsolamentoE")} [kPa]
          </label>
          <input
            class="form-input"
            id="grid-iso-e"
            type="number"
            step={0.01}
            defaultValue={11000}
            placeholder={t("IsolamentoE")}
            {...register("HooksIsoE", {
              required: t("Required"),
              min: {
                value: 100,
                message: t("Minimo") + " 100",
              },
              max: {
                value: 10000000000,
                message: t("Massimo") + " 10.0e12",
              },
            })}
          />
          <p class="form-error">{errors.HooksIsoE?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-iso-sp">
            {t("IsolamentoSp")}
          </label>
          <input
            class="form-input"
            id="grid-iso-sp"
            type="number"
            step={1}
            defaultValue={70}
            placeholder={t("IsolamentoSp")}
            {...register("HooksIsoSp", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeTotalH(e);
              },
              min: {
                value: 60,
                message: t("Minimo") + " 60mm",
              },
              max: {
                value: 320,
                message: t("Massimo") + " 320mm",
              },
            })}
          />
          <p class="form-error">{errors.HooksIsoSp?.message}</p>
        </div>
        <div class="form-col1_6"></div>
        <div class="form-col1_6"></div>

        <ColoredLine text={t("Connettori")} />
        <ScrewPicker ref={ScrewPickerRef} maxL={800} nodeTypeId={8} eta={true} minL={230} startvalue={204} linkdoc={"ETA120373.pdf"} />
        <div class="form-col1_6">
          <label class="form-label" for="grid-Angle">
            Angolo connettori [°]
          </label>
          <input
            class="form-input"
            id="grid-Angle"
            type="number"
            step={0.1}
            defaultValue={60}
            placeholder={t("ScrewAngle")}
            {...register("HookAlfa", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeTotalH(e);
              },
              min: {
                value: 30,
                message: t("Minimo") + " 30°",
              },
              max: {
                value: 90,
                message: t("Massimo") + " 90°",
              },
            })}
          />
          <p class="form-error">{errors.HookAlfa?.message}</p>
        </div>
        <div class="form-col1_6" hidden={resistant <= 0}>
          <label class="form-label" for="grid-Ic">
            {t("InterasseConnettori")}<sub>viti</sub>[mm]
          </label>
          <input
            class="form-input"
            id="grid-Ic"
            type="number"
            step={1}
            defaultValue={250}
            placeholder="Iviti [mm]"
            {...register("HookIc1", {
              required: t("Required"),
              min: {
                value: 80,
                message: t("Minimo") + " 80mm",
              },
              max: {
                value: 1500,
                message: t("Massimo") + " 1000mm",
              },
            })}
          />
          <p class="form-error">{errors.HookIc1?.message}</p>
        </div>
        <div class="form-col1_6" hidden={resistant > 0}>
          <label class="form-label" for="grid-Ic">
            {t("InterasseCoppia")}<sub>c</sub>[mm]
          </label>
          <input
            class="form-input"
            id="grid-Ic"
            type="number"
            step={1}
            defaultValue={240}
            placeholder="Icoppia [mm]"
            {...register("HookIc", {
              required: t("Required"),
              min: {
                value: 80,
                message: t("Minimo") + " 80mm",
              },
              max: {
                value: 1500,
                message: t("Massimo") + " 1000mm",
              },
            })}
          />
          <p class="form-error">{errors.HookIc?.message}</p>
        </div>
        <div class="form-col1_6" hidden={resistant === 1 && facade === 0}>
          <label class="form-label" for="grid-StepX">
            {t("ConnectorStep90i")}<sub>viti</sub>[mm]
          </label>
          <input
            class="form-input"
            id="grid-StepX"
            type="number"
            step={1}
            defaultValue={80}
            placeholder="Iviti [mm]"
            {...register("HookStepX", {
              required: t("Required"),
              min: {
                value: 30,
                message: t("Minimo") + "30mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p class="form-error">{errors.HookStepX?.message}</p>
        </div>
        <div class="form-col1_6"></div>
        <div class="form-col1_6"></div>
        <div class="form-col1_6" hidden={resistant <= 0}></div>

        <div class="form-col1_5 py-5 px-3">
          <button name="btn1" className="bg-green-700 text-white font-bold py-2 px-3 rounded" onClick={() => SetCreateReport(0)}>
            {t("Check")}
          </button>
          <button
            name="btn2"
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-3 ml-3 rounded align-right"
            onClick={() => SetCreateReport(1)}
          >
            {t("Report")}
          </button>
        </div>
        <div class="form-col1_2 py-5">
        {
            (validData) ? ((Ratio > 1.0) ? (<p className="form-result" hidden={!validData}>{Ratio}</p>): (<p className="form-result-ok" hidden={!validData}>{Ratio}</p>)) : (<div/>)
          }
          {
            (Ratio > 1.0 || !validData) ? (<p className="form-result">{resultMessages}</p>): (<p className="form-result-ok">{resultMessages}</p>)
          }
        </div>
      </div>
    </form>
  );
}
